import { Link, Navigate, useLocation } from 'react-router-dom';
import { useCapabilities } from '../admin/CapabilityProvider';
import { communicationsDestination } from './communicationsDestination.mjs';

// Existing legacy route guards remain in App; canonical module guards also apply.
export default function LegacyCommunicationsRoute() {
  const { pathname, search, hash } = useLocation();
  const { has } = useCapabilities();
  const destination = communicationsDestination(pathname);
  const canOpen = has('admin:clc-communications:read');
  if (destination && canOpen) {
    return <Navigate replace to={{ pathname: destination, search, hash }} />;
  }
  const retiredInbox = destination === null;
  return (
    <section className="admin-page" style={{ maxWidth: 800, margin: '0 auto', padding: '2rem 1rem' }}>
      <h1>{retiredInbox ? 'The old Communications Inbox has been retired' : 'Communications has moved'}</h1>
      <p>{retiredInbox
        ? 'This Inbox and its thread pages are no longer available. Stored messages and delivery history have not been deleted.'
        : 'Communications now lives in the CLC Communications workspace.'}</p>
      {canOpen
        ? <Link to="/modules/clc-communications/queue">Open CLC Communications</Link>
        : <p>Your account needs access to the CLC Communications workspace. Contact your administrator.</p>}
      <p><Link to="/admin">Back to Command Center</Link></p>
    </section>
  );
}
